import {Component, OnInit, AfterViewInit} from '@angular/core';
import {FormService} from '../form.service';
import {AdvicePdfService} from '../advice-pdf.service';
import {Router} from '@angular/router';
import {SubmissionsService} from 'app/services/submissions.service';
import {ReCaptchaV3Service} from "ngx-captcha";
import {Observable} from 'rxjs';

@Component({
    selector: 'third-step',
    templateUrl: './third-step.component.html',
    styleUrls: ['../advice-form.component.scss', './third-step.component.scss']
})
export class ThirdStepComponent implements OnInit {
    readonly SITE_KEY = '6LdnMQopAAAAAJn25SJ19JPz4afrWy0hsO7E3yX2';
    action = 'register';
    token: string = '';

    sActions: number[] = [];
    defaultAction: number[] = [2, 7, 11, 17, 23];
    expandedAction: { [key: number]: boolean } = {};

    constructor(
        private formService: FormService,
        private advicePdfService: AdvicePdfService,
        private router: Router,
        private submissionService: SubmissionsService,
        private reCaptchaV3Service: ReCaptchaV3Service
    ) {
    }

    ngOnInit(): void {
        // console.log("third step init");
        this.sActions = this.formService.sActions;
        this.sActions = this.sActions.filter((action) => {
            return !this.defaultAction.includes(action)
        });
        // console.log(this.formService.form, 'user form');
        // console.log(this.formService.statement, 'user statement');
        // console.log(this.formService.matrixAnswer, 'user matrix answer');


        this.generateToken().subscribe((token) => {
                this.postSubmission();
            }
        );

        if (this.sActions.length == 0) {
            console.log("no data");
            this.router.navigateByUrl('SOT/(advice-form:first-step)');
        }
        this.sActions.forEach((action) => {
            this.expandedAction[action] = true;
        });
    }

    postSubmission() {
        console.log("post submission");
        let submission: any = {};
        submission['title'] = this.formService.form?.value.title;
        submission['name'] = this.formService.form?.value.name;
        submission['surname'] = this.formService.form?.value.surname;
        submission['phone'] = this.formService.form?.value.phone;
        submission['organisation'] = this.formService.form?.value.organisation;
        submission['organisation_type'] = this.formService.form?.value.organisation_type;
        submission['gender'] = this.formService.form?.value.gender;
        submission['country'] = this.formService.form?.value.country;
        submission['grants_agreement_number'] = this.formService.form?.value.grants_agreement_number;
        submission['project_acronym'] = this.formService.form?.value.project_acronym;
        submission['full_project_name'] = this.formService.form?.value.full_project_name;
        submission['project_website'] = this.formService.form?.value.project_website;
        submission['statement'] = this.formService.statement;
        submission['answers'] = this.formService.matrixAnswer;
        submission['userRoles'] = this.formService.userRoles;
        submission['username'] = this.formService.username;
        submission['token'] = this.token;
        // console.log(submission, 'submission');
        this.submissionService.createSubmission(submission).subscribe((res) => {
            // console.log(res, 'response');
        });
    }

    generateToken() {
        return new Observable((observer) => {
                this.reCaptchaV3Service.execute(this.SITE_KEY, this.action, (token) => {
                    this.token = token;
                    observer.next(token);
                    observer.complete();
                });
            }
        );
    }

    getActionById(id: number) {
        return this.formService.getActionById(id);
    }

    expand(action: number): void {
        this.expandedAction[action] = !this.expandedAction[action];
    }

    isExpanded(action: number): boolean {
        return this.expandedAction[action];
    }


    export() {
        this.advicePdfService.export(
            {
                grants_agreement_number: this.formService.form?.value.grants_agreement_number,
                project_acronym: this.formService.form?.value.project_acronym,
                full_project_name: this.formService.form?.value.full_project_name,
                project_website: this.formService.form?.value.project_website,
            },
            this.formService,
            this.sActions,
            this.defaultAction
        );
    }

}
